import config from '../configs/config.json';
import axios from 'axios';
import errorMessage from './../utils/ErrorMessage';

class Service {
    constructor(){
        const query = window.location.search.substring(1);
        const qs = this._parse_query_string(query);
        this.server = config.nodejs.server;
        let headers = {} 
        qs.auth_token && (headers['Authorization'] = `Bearer ${qs.auth_token}`);
        this.axiosInstance = axios.create({
          withCredentials: true,
          baseURL: config.nodejs.server,
          headers: headers
        })

        this.axiosInstance.interceptors.request.use(function (config) {
          config.params = config.params || {};
          qs.usid && (config.params['user_identifier'] = qs.usid);
          qs.uf && (config.params['uf'] = qs.uf);
          return config;
        });
        
        // Add a response interceptor
        this.axiosInstance.interceptors.response.use(function (response) {
          // Any status code that lie within the range of 2xx cause this function to trigger
          // Do something with response data
          return response;
        }, function (error) {
          
          if(error.response && error.response.status === 401){
            
            errorMessage('', 'CMK099', undefined, 'Acesso não autorizado');

          } else {
            return Promise.reject(error);
          }
        });
    }
    loadImage(imageCode) {
     imageCode = imageCode.indexOf('.png') >= 0? imageCode.replace('.png', ''): imageCode;
      return `${config.nodejs.server}/images/${imageCode}`;
    }
    loadImageFile(imageCode) {
      return (fetch(this.loadImage(imageCode))
      .then(function(res){return res.arrayBuffer();})
      .then(function(buf){return new File([buf], imageCode + '.webp',{type:"image/webp"});})
      );
    }
    formatErrorMessage(response, actionCode, defaultErrorMessage) {
      if(response){
        if(response.data?.payload) {
          if(response.data.payload.errors) {
            const errors = response.data.payload.errors;
            let errorsFormatted = errors.reduce((reducer, element, index) => {
              return reducer += `<li>${element.msg}</li>${errors.length === (index)? '</ul>':'' }`;
            }, "Você precisa corrigir algumas informações: <ul>");
            errorMessage('', response.data.errorCode? response.data.errorCode:'CMKT-' + actionCode, errorsFormatted, defaultErrorMessage)
          } else {
            if(response.status !== 401) {
              errorMessage('', response.data.errorCode? response.data.errorCode:'CMKT-' + actionCode, response.data.message, defaultErrorMessage)
            }
          }
        } else {
          if(response.status !== 401) {
            if(response.data.type) {
              errorMessage('', response.data.errorCode? response.data.errorCode: 'CMKT-' + actionCode, response.data.message, defaultErrorMessage)
            } else {
              this._showCommonErrorMessage(response, actionCode)
            }
          }
        }
      }else{
        // errorMessage('', `CMKX-${actionCode}`, 'Falha ao executar a ação desejada. Entre em contato com o suporte')
      }
    } 
    _showCommonErrorMessage(response, actionCode) {
      if(response.status === 404) {
        errorMessage('', `CMK044-${actionCode}`, 'Ação solicitada não se encontra disponivel. Entre em contato com o suporte')
      } else if(response.status === 400) {
        // errorMessage('', `CMK004-${actionCode}`, 'Falha ao executar a ação desejada. Entre em contato com o suporte')
      } else if (response.status >= 500) {
        // errorMessage('', `CMK005-${actionCode}`, 'Falha ao executar a ação desejada. Entre em contato com o suporte')
      }
    }
    _parse_query_string(query) {
      var vars = query.split("&");
      var query_string = {};
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        var key = decodeURIComponent(pair[0]);
        var value = decodeURIComponent(pair[1]);
        // If first entry with this name
        if (typeof query_string[key] === "undefined") {
          query_string[key] = decodeURIComponent(value);
          // If second entry with this name
        } else if (typeof query_string[key] === "string") {
          var arr = [query_string[key], decodeURIComponent(value)];
          query_string[key] = arr;
          // If third or later entry with this name
        } else {
          query_string[key].push(decodeURIComponent(value));
        }
      }
      return query_string;
    }
}
export default Service;